import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import { HOME_FEATURE_SLIDER_ITEMS } from '../../constants/projectCaseStudies'
import { SLICK_BREAKPOINT_KEY } from '../../constants/slickBreakpoints'

const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    [SLICK_BREAKPOINT_KEY]: [
        { breakpoint: 991, settings: { slidesToShow: 2 } },
        { breakpoint: 767.98, settings: { arrows: false, slidesToShow: 1 } },
    ],
}

const imgBase = `${process.env.PUBLIC_URL || ''}`

const FeatureSliderOne = () => {
    return (
        <Fragment>
            <Slider className="row gx-0 blog-active-one" data-aos="fade-up" data-aos-delay={100} {...settings}>
                {HOME_FEATURE_SLIDER_ITEMS.map((val) => {
                    const detailTo = `/project-details/${val.slug}`
                    const tagClass = ['tag', val.tagModifier].filter(Boolean).join(' ')
                    return (
                        <div key={val.slug} className="col-lg-4">
                            <div className="blog-style-one">
                                <div className="blog-thumb">
                                    <img
                                        className="w-100"
                                        src={`${imgBase}${val.imgSrc}`}
                                        alt={`${val.title} 구축 사례`}
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <Link to={detailTo} className={tagClass}>
                                        {val.tag}
                                    </Link>
                                </div>
                                <div className="blog-content">
                                    <h4>
                                        <Link className="blog-title" to={detailTo}>
                                            {val.title}
                                        </Link>
                                    </h4>
                                    <p>{val.desc}</p>
                                    <div className="blog-meta">
                                        <Link to={detailTo}>
                                            <i className="bi bi-arrow-up-right" />
                                            상세 보기
                                        </Link>
                                        <Link to="/project-grid">
                                            <i className="bi bi-grid-3x3-gap" />
                                            전체 사례
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
        </Fragment>
    )
}

export default FeatureSliderOne
